import { createContext, useContext } from "react";

export const DashBoardContext=createContext();